import React, { useState } from 'react';
import Icon from 'jsx/components/core/icons/Icon';
import Listview from "../../core/form/components/Listview";
import FormInput from '../../core/form/components/FormInput';
import { controlDefaults, validateChange, initControls } from "../../core/form/lib/validateForm";

const UserOrgsLsv = (props) => {
  const {
    rows,
    lookupOptions,
    onAdd,
    onRemove
  } = props;

  let [controls, setControls] = useState(initControls({
    org_id: {
      ...controlDefaults,
      fieldName: 'org_id',
      name: 'org_id',
      type: 'select',
      options: [],
      value: ''
    }
  }));
  let [changed, setChanged] = useState(false);

  if (lookupOptions && lookupOptions.length > 0) {
    controls.org_id.options = lookupOptions;
  }

  const handleChange = (event) => {
    controls = validateChange(event, controls);
    setControls(controls)
    setChanged(!changed);
    onAdd(controls.org_id.value); 
    controls.org_id.value = '';
  }

  const renderRows = (headers, row) => {
    const tableTd = headers.map((header, index) => {
      switch (header.field) {
        case 'remove': return (
          <td key={index} className={header.classes}><Icon name="trash" style={{ cursor: 'pointer' }} onClick={() => { onRemove(row) }} /></td>
        )
        default: return (
          <td key={index} className={header.classes}>{row.org[header.field]}</td>
        )
      }
    });

    return tableTd;
  }

  const headers = [
    { caption: 'Name', field: 'name', classes: 'text-left' },
    { caption: '', field: 'remove', classes: 'text-end text-danger' },
  ]

  const tableHeadTh = headers.map((header, index) =>
    <th key={index} className={header.classes}>{header.caption}</th>
  );

  let tableBodyTr = (<tr></tr>);
  const haveRows = (rows && rows.length > 0);
  if (haveRows) {
    tableBodyTr = rows.map((row, index) =>
      <tr key={index}>
        {renderRows(headers, row)}
      </tr>
    );
  }

  const iconName = 'user-tag';
  const emptyCaption = 'No Organisations found';

  return (
    <React.Fragment>
      <div className="d-flex justify-content-end bg-light p-1 mb-2 rounded">
        <div className="d-flex d-flex-row ml-2 mr-2">
          <FormInput handleChange={handleChange} control={controls.org_id} />
        </div>
      </div>
      <Listview rows={rows} tableHeadTh={tableHeadTh} tableBodyTr={tableBodyTr} iconName={iconName} emptyCaption={emptyCaption} />
    </React.Fragment>
  );
}

export default UserOrgsLsv;
